import { canViewInsuranceCampaigns } from '@/general/src/auth/can.js'
import { zGetInsuranceCampaignsIssuesStatsForAdminEndpointInput } from '@/general/src/insuranceCampaign/routes/getInsuranceCampaignsIssuesStatsForAdmin/input.js'
import { getInsuranceScenarioTitleOrUnknown } from '@/general/src/insuranceScenario/shared.js'
import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { Textfieldy, useFormy } from '@/webapp/src/lib/formy.js'
import { withPageWrapper } from '@/webapp/src/lib/pageWrapper.js'
import { adminInsuranceCampaignListRoute, adminInsuranceCampaignViewRoute } from '@/webapp/src/lib/routes.js'
import { SectionWrapper } from '@/webapp/src/lib/sectionWrapper.js'
import { trpc } from '@/webapp/src/lib/trpc.js'
import { Block, FormItems, Link, Segment, Table } from '@/webapp/src/lib/uninty.components.js'
import { formatDate } from 'date-fns/format'
import { subDays } from 'date-fns/subDays'
import { useEffect, useMemo, useState } from 'react'
import type { z } from 'zod'

type GetInsuranceCampaignsIssuesStatsForAdminEndpointInput = z.infer<
  typeof zGetInsuranceCampaignsIssuesStatsForAdminEndpointInput
>
export const AdminIssuesStatsPage = withPageWrapper({
  title: 'Анализ ошибок сценариев',
  Layout: GeneralLayout,
  authorizedAdminsOnly: true,
  checkAccess: ({ ctx }) => canViewInsuranceCampaigns(ctx.me.admin),
})(() => {
  const initalValues = useMemo(() => {
    return {
      fromDate: subDays(new Date(), 7).toISOString(),
      toDate: new Date().toISOString(),
    }
  }, [])
  const [filter, setFilter] = useState(initalValues)
  const formy = useFormy({
    initialValues: initalValues as never,
    validationSchema: zGetInsuranceCampaignsIssuesStatsForAdminEndpointInput,
  })
  useEffect(() => {
    void formy.setFieldTouched('fromDate', true, true)
    void formy.setFieldTouched('toDate', true, true)
  }, [formy.values])
  useEffect(() => {
    if (zGetInsuranceCampaignsIssuesStatsForAdminEndpointInput.safeParse(formy.values).success) {
      setFilter(formy.values as never)
    }
  }, [JSON.stringify(formy.values)])
  return (
    <Block fcnw>
      <Segment title="Анализ ошибок сценариев" size="m">
        <FormItems>
          <FormItems>
            <Textfieldy label="Дата от" {...formy.getFieldProps('fromDate')} />
            <Textfieldy label="Дата до" {...formy.getFieldProps('toDate')} />
          </FormItems>
          <SectionWrapper
            useQuery={() =>
              trpc.getInsuranceCampaignsIssuesStatsForAdmin.useQuery({
                ...(filter as never as GetInsuranceCampaignsIssuesStatsForAdminEndpointInput),
              })
            }
            setProps={({ queryResult }) => ({
              issuesStats: queryResult.data.issuesStats,
            })}
          >
            {({ issuesStats }) => {
              return (
                <Table
                  records={issuesStats}
                  columns={[
                    { heading: 'Кол-во', body: (record) => record.count, width: 70 },
                    {
                      heading: 'Последнее появление',
                      body: (record) => formatDate(record.lastOccurrenceAt, 'dd.MM.yyyy HH:mm'),
                      width: 100,
                    },
                    {
                      heading: 'SN последней кампании',
                      body: (record) => (
                        <Link
                          href={adminInsuranceCampaignViewRoute.get({
                            insuranceCampaignSn: record.lastOccurrenceInsuranceCampaignSn,
                          })}
                        >
                          {record.lastOccurrenceInsuranceCampaignSn}
                        </Link>
                      ),
                      width: 100,
                    },
                    {
                      heading: 'Сценарий',
                      body: (record) =>
                        getInsuranceScenarioTitleOrUnknown({ insuranceScenarioKey: record.insuranceScenarioKey }),
                      width: 200,
                    },
                    {
                      heading: 'Шаг',
                      body: (record) => record.step,
                      width: 400,
                    },
                    {
                      heading: 'Сообщение',
                      body: (record) => (
                        <>
                          <Link
                            // href={adminInsuranceCampaignListRoute.get({
                            //   searchParams: {
                            //     insuranceCampaignIssueText: record.message,
                            //   },
                            // })}
                            href={`${adminInsuranceCampaignListRoute.get()}?${new URLSearchParams({
                              insuranceCampaignIssueHash: record.hash,
                            }).toString()}`}
                          >
                            Показать все
                          </Link>
                          {record.message}
                        </>
                      ),
                      width: 800,
                    },
                    {
                      heading: 'Ошибка',
                      body: (record) => <>{record.cause}</>,
                      width: 800,
                    },
                  ]}
                />
              )
            }}
          </SectionWrapper>
        </FormItems>
      </Segment>
    </Block>
  )
})
